"use client";

import React from "react";
import { Badge } from "@/components/ui/badge";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const teamMembers = [{
  name: "Dr. Sarah Jenkins",
  position: "Senior Veterinarian",
  bio: "With over 15 years in urban pet care, Dr. Jenkins specializes in feline internal medicine and stress-free handling.",
  expertise: "Internal Medicine",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687484/img/vet_sarah_jenkins.png"
}, {
  name: "Ella Thompson",
  position: "Lead Veterinary Tech",
  bio: "Mark brings a gentle touch to every exam, ensuring your furry companions feel safe and loved during their visit.",
  expertise: "Patient Care",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687484/img/vet_mark_thompson_new.png"
}];
export default function MeetOurExperts() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="234477" id="meet-our-experts" className="bg-background text-foreground py-24 px-6 overflow-hidden">
      <div className="max-w-6xl mx-auto">
        <div ref={headerRef} className={`text-center max-w-2xl mx-auto mb-16 transition-all duration-700 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-default text-4xl md:text-5xl font-bold tracking-tight mb-4 text-foreground">
            Meet Our Medical Team
          </h2>
          <p className="text-muted-foreground text-lg font-default">
            Our compassionate experts are dedicated to providing the highest standard of care for your beloved pets.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl mx-auto">
          {teamMembers.map((member, i) => <TeamMemberCard key={member.name} member={member} index={i} />)}
        </div>
      </div>
    </section>;
}
function TeamMemberCard({
  member,
  index
}: {
  member: typeof teamMembers[0];
  index: number;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const delay = index * 150;
  return <div data-index={index} ref={ref} style={{
    transitionDelay: `${delay}ms`
  }} className={`group relative overflow-hidden rounded-3xl aspect-[3/4] bg-muted shadow-xl transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
      {}
      <img src={member.image} alt={`Portrait of ${member.name}`} className="absolute inset-0 w-full h-full object-cover transition-all duration-700 ease-in-out group-hover:scale-105" />

      {}
      <div className="absolute inset-0 bg-gradient-to-t from-background/95 via-background/10 to-transparent opacity-90 group-hover:opacity-70 transition-opacity duration-500" />

      {}
      <Badge variant="default" className="absolute top-5 right-5 z-20 shadow-md font-default font-semibold tracking-wide px-3 py-1 bg-ring text-primary-foreground">
        {member.expertise}
      </Badge>

      {}
      <div className="absolute inset-x-0 bottom-0 bg-card/40 backdrop-blur-xl border-t border-border/50 p-6 transition-transform duration-500 ease-in-out translate-y-[calc(100%-5.5rem)] group-hover:translate-y-0">
        <div className="h-[5.5rem] flex flex-col justify-start">
          <h3 className="font-default text-2xl font-bold text-foreground tracking-tight">
            {member.name}
          </h3>
          <p className="text-ring font-medium mt-1 font-default">{member.position}</p>
        </div>
        
        <div className="grid grid-rows-[0fr] group-hover:grid-rows-[1fr] transition-all duration-500 ease-in-out">
          <div className="overflow-hidden">
            <p className="text-foreground/90 text-sm leading-relaxed pt-2 pb-1 opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100 font-default">
              {member.bio}
            </p>
          </div>
        </div>
      </div>
    </div>;
}